import React from 'react'
import { SVGProps } from 'react'

export default function EnaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 390 390" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M194.996 3.52681H195.004C300.751 3.52681 386.476 89.2521 386.476 195V195.007C386.476 300.754 300.751 386.48 195.004 386.48H194.996C89.2489 386.48 3.52364 300.754 3.52364 195.007V195C3.52364 89.2521 89.2489 3.52681 194.996 3.52681Z"
        fill="#111111"
        stroke="#111111"
        strokeWidth="7.05362"
      />
      <path
        d="M195.004 0H194.996C87.3011 0 -0.00317383 87.3043 -0.00317383 195V195.007C-0.00317383 302.702 87.3011 390.006 194.996 390.006H195.004C302.699 390.006 390.003 302.702 390.003 195.007V195C390.003 87.3043 302.699 0 195.004 0Z"
        fill="url(#paint0_radial_4638_700)"
        fillOpacity="0.7"
      />
      <path
        d="M194.996 3.57146H195.004C300.726 3.57146 386.432 89.2767 386.432 195V195.007C386.432 300.73 300.726 386.435 195.004 386.435H194.996C89.2735 386.435 3.56828 300.73 3.56828 195.007V195C3.56828 89.2767 89.2735 3.57146 194.996 3.57146Z"
        stroke="white"
        strokeWidth="7.14291"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.331 104.311H148.175L145.481 107.475L75.9306 189.167L70.9658 194.999L75.9306 200.83L145.481 282.523L148.175 285.687H152.331H277.546H286.542V276.691V224.757H268.55V267.695H172.003L229.787 200.883L234.877 194.999L229.787 189.114L172.003 122.302H268.55V165.24H286.542V113.307V104.311H277.546H152.331ZM152.384 127.121L94.5943 194.999L152.384 262.877L211.09 194.999L152.384 127.121Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4638_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(195.419 56.9459) rotate(90) scale(411.151 289.409)"
        >
          <stop offset="0.03125" stopColor="#3A3A3A" />
          <stop offset="1" stopColor="#1C1C1C" />
        </radialGradient>
      </defs>
    </svg>
  )
}
